import { render, staticRenderFns } from "./RightTabs.vue?vue&type=template&id=c9001b2e&scoped=true&"
import script from "./RightTabs.vue?vue&type=script&lang=js&"
export * from "./RightTabs.vue?vue&type=script&lang=js&"
import style0 from "./RightTabs.vue?vue&type=style&index=0&id=c9001b2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9001b2e",
  null
  
)

export default component.exports